import { ContainerModule } from './container/container.module';

import { HeadController } from './head/head.controller';

export const ComponentsModule = angular.module('oo.multilocation.picker.components', [
    ContainerModule
])
    .controller('headController', HeadController)
    .name;
